import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { usarSiscred } from '../estado/siscred';
import { requisicaoAutenticada } from './http';

/** O SISCRED aberto ou encerrado (27/10/2026) — espelha `apps/api/src/modules/icms/siscred.*`. */
export interface SituacaoDoSiscred {
  readonly exercicioVigente: number;
  readonly encerramentos: readonly { readonly ano: number; readonly encerradoEm: string }[];
}

export const CHAVE_DO_SISCRED = ['icms', 'siscred'] as const;

export const carregarSiscred = (): Promise<SituacaoDoSiscred> =>
  requisicaoAutenticada('/icms/siscred');

export const encerrarSiscred = (ano: number, encerradoEm: string): Promise<SituacaoDoSiscred> =>
  requisicaoAutenticada(`/icms/siscred/${ano}`, { metodo: 'PUT', corpo: { encerradoEm } });

export const reabrirSiscred = (ano: number): Promise<SituacaoDoSiscred> =>
  requisicaoAutenticada(`/icms/siscred/${ano}`, { metodo: 'DELETE' });

/**
 * Lê os SISCRED encerrados e guarda no estado — é dele que `exercicioVigente`
 * tira o ano. Mora na casca do app: uma leitura ao entrar, e de novo quando
 * alguém marca ou reabre (a consulta é invalidada).
 */
export function useCarregarSiscred(): void {
  const consulta = useQuery({
    queryKey: CHAVE_DO_SISCRED,
    queryFn: carregarSiscred,
    staleTime: 5 * 60_000,
  });
  const definir = usarSiscred((s) => s.definir);
  useEffect(() => {
    if (consulta.data === undefined) return;
    definir(
      consulta.data.encerramentos.map((e) => ({
        ano: e.ano,
        encerradoEm: new Date(`${e.encerradoEm}T00:00:00`),
      })),
    );
  }, [consulta.data, definir]);
}
